// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"7971cb6a","787":"170e9299","948":"30b290ff","964":"ae410542"}[chunkId] + ".chunk.js";
};